import { projectFromFirestore } from '@parallel-fluidics/shared/models/projects';
import {
  collection,
  getFirestore,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { useMemo } from 'react';

import useRealtimeDocs from './use-realtimeDocs';

export default function useProjects({ isInternal = null } = {}) {
  const projectsQuery = useMemo(() => {
    if (isInternal === null) {
      return query(
        collection(getFirestore(), 'projects'),
        orderBy('name', 'asc'),
      );
    }
    return query(
      collection(getFirestore(), 'projects'),
      where('isInternal', '==', isInternal),
      orderBy('name', 'desc'),
    );
  }, [isInternal]);

  const { data: projects, status } = useRealtimeDocs({
    query: projectsQuery,
    transformData: projectFromFirestore,
  });

  const projectOptions = useMemo(
    () => projects.map((project) => {
      if (project.isInternal) {
        return {
          value: project.name,
          label: `${project.name} - ${project.description}`,
          display: project.description,
          id: project.id,
        };
      }
      if (project.partId) {
        const quoteId = project.partId.substring(0, 6).toUpperCase();
        return {
          value: project.name,
          label: `${project.name} - #${quoteId} (${project.filename})`,
          display: project.filename,
          partId: project.partId,
          id: project.id,
        };
      }
      return {
        value: project.name,
        label: `${project.name} (${project.filename})`,
        display: project.filename,
        id: project.id,
      };
    }),
    [projects],
  );

  return { projects, projectOptions, isLoading: status === 'loading' };
}
